import { motion } from "framer-motion";
import { Battery, Zap } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface DashboardHeaderProps {
  lastUpdate: Date | null;
}

export const DashboardHeader = ({ lastUpdate }: DashboardHeaderProps) => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="border-b border-border bg-card/50 backdrop-blur-sm"
    >
      <div className="container mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="relative">
                <Battery className="h-8 w-8 text-primary" />
                <Zap className="absolute -right-1 -top-1 h-4 w-4 text-primary animate-glow-pulse" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-foreground">
                  Consus Energy Dashboard
                </h1>
                <p className="text-sm text-muted-foreground">
                  Live Energy Value Monitoring
                </p>
              </div>
            </div>
          </div>
          
          {lastUpdate && (
            <div className="text-right">
              <p className="text-xs text-muted-foreground">Last updated</p>
              <p className="text-sm font-medium text-foreground">
                {formatDistanceToNow(lastUpdate, { addSuffix: true })}
              </p>
            </div>
          )}
        </div>
      </div>
    </motion.header>
  );
};
